import { actionsStyles as styles } from "@iewccouk/Overrides/Widgets/ProductList/ProductListActions";
import { colorStrings } from "@iewccouk/Utilities/variables";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

// Verndale Customization Start - PUTUP prices styles
styles.addToCartWrapperPutup = {
    css: css`
        display: flex;
        margin-top: 10px;
        width: 100%;
        flex-wrap: wrap;

        &.wrapper-quote {
            margin-top: 0;
            flex-wrap: nowrap;
            flex-direction: row;
            align-items: flex-end;
            gap: 5px;
        }
    `,
};

styles.addToCartButtonPutup = {
    css: css`
        width: 100%;
    `,
};

styles.quantityOrderedPutup = {
    productQuantityOrderedStyles: {
        cssOverrides: {
            formField: css`
                inline-size: 100%;

                input:not(.react-datetime-picker__inputGroup__input) {
                    background-color: ${getColor(colorStrings.commonGlobalWhite)};
                }
            `,
        },
    },
};
// Verndale Customization End - PUTUP prices styles
